import {Tq_OsmSearch} from "../../classes/TqClasses";
import {getRequest_fp} from "@/scripts/Server/S_HttpRequests";

// osm_getLocation_f
export const map_getLocation_f = (searchText_s , cb_f) => {

    let url_s = 'https://nominatim.openstreetmap.org/?addressdetails=1&format=json&limit=1&q=' + searchText_s

    return getRequest_fp(url_s).then( (ans)=> {
        let OsmSearch_c = new Tq_OsmSearch(ans[0])
        cb_f(OsmSearch_c)
    })

}

// osm_getLocationWithIp_fp
export const map_getLocationWithIp_fp = () => {

    let url_s = 'https://api.ipgeolocation.io/ipgeo?apiKey=85b2618382d34ce3be16d6f8557fb32b'
    return getRequest_fp(url_s)

}


// map_geoHash_encode_fp
let geoHashNumOfChars_n = 9
let GeoHash_o;
export const map_geoHash_encode_fp = (lat_n, lng_n) => {

    if(!GeoHash_o){
        GeoHash_o = require('ngeohash')
    }

    return GeoHash_o.encode(lat_n, lng_n, geoHashNumOfChars_n)
}

// map_geoHash_bboxes_fp
export const map_geoHash_bboxes_fp = (minLat_n, minLon_n, maxLat_n, maxLon_n) => {

    if(!GeoHash_o){
        GeoHash_o = require('ngeohash')
    }

    let ans_as = []
    let i = 1
    while(ans_as.length < 9 && i < 9){
        let newAns_as = GeoHash_o.bboxes(minLat_n, minLon_n, maxLat_n, maxLon_n, i)

        if(newAns_as.length > 9){
            break;
        }

        ans_as = newAns_as
        i++
    }

    return ans_as
}

// mao_geoHash_lastHash_fs
export const mao_geoHash_lastHash_fs = (geoHash_s) => {
    let geoHash_prefix_s = geoHash_s.substring(0,geoHash_s.length-1)
    let geoHash_suffix_s = String.fromCharCode(geoHash_s.substring(geoHash_s.length-1).charCodeAt()+1)

    return geoHash_prefix_s + geoHash_suffix_s
}

// map_distanceTwoPointsMeters_fn
const distance_byId_o = {}
export const map_distanceTwoPointsMeters_fn = ({lat1, lon1, lat2, lon2}) => {

    const distanceId = `${lat1}_${lon1}_${lat2}_${lon2}`
    if(distance_byId_o[distanceId]){
        return distance_byId_o[distanceId]
    }

    // Converts numeric degrees to radians
    function toRad(Value) {
        return Value * Math.PI / 180;
    }

    const R = 6371*1000; // meters
    const dLat = toRad(lat2-lat1);
    const dLon = toRad(lon2-lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c;

    distance_byId_o[distanceId] = d.toFixed(0)

    return distance_byId_o[distanceId]
}










